import React, { Fragment } from 'react';
import { I18n } from '@kineticdata/react';
import { C } from '@kineticdata/bundle-common';
import classNames from 'classnames';
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from 'reactstrap';

export const PaginationBar = ({
  className,
  paging,
  previousPage,
  nextPage,
  startIndex,
  endIndex,
  count,
  countDone,
  pageSize,
  changePageSize,
  currentPage,
  pageCount,
  goToPage,
}) => (
  <div
    className={classNames('pagination-bar', className, {
      'pagination-bar--advanced': !!pageSize,
    })}
  >
    <div className="pagination-bar__group">
      <I18n
        render={translate => (
          <button
            className="btn btn-icon"
            onClick={previousPage}
            aria-label="Previous Page"
            disabled={paging || !previousPage}
            title={translate('Previous Page')}
          >
            <span className="icon">
              <span className="fa fa-fw fa-angle-left" />
            </span>
          </button>
        )}
      />
      {!!pageCount &&
        typeof goToPage === 'function' && (
          <>
            <button
              className={classNames('btn btn-link', {
                active: currentPage === 0,
              })}
              onClick={goToPage(0)}
              aria-label={`Go To Page ${1}`}
              disabled={paging || currentPage === 0}
              title={1}
            >
              1
            </button>
            {Array.from(
              { length: 3 },
              (_, i) =>
                Math.min(Math.max(currentPage - 1, 1), pageCount - 4) + i,
            )
              .filter(p => p > 0 && p < pageCount - 1)
              .map((pageNumber, i, list) => (
                <Fragment key={`page-number-${i}`}>
                  {i === 0 &&
                    pageNumber > 1 && (
                      <span className="fa fa-fw fa-sm fa-ellipsis-h text-muted" />
                    )}
                  <button
                    className={classNames('btn btn-link', {
                      active: pageNumber === currentPage,
                    })}
                    onClick={goToPage(pageNumber)}
                    aria-label={`Go To Page ${pageNumber + 1}`}
                    disabled={paging || pageNumber === currentPage}
                    title={pageNumber + 1}
                  >
                    {pageNumber + 1}
                  </button>
                  {i === list.length - 1 &&
                    pageNumber < pageCount - 2 && (
                      <span className="fa fa-fw fa-sm fa-ellipsis-h text-muted" />
                    )}
                </Fragment>
              ))}
            {pageCount !== 1 && (
              <button
                className={classNames('btn btn-link', {
                  active: currentPage === pageCount - 1,
                })}
                onClick={goToPage(pageCount - 1)}
                aria-label={`Go To Page ${pageCount}`}
                disabled={paging || currentPage === pageCount - 1}
                title={pageCount}
              >
                {pageCount}
              </button>
            )}
          </>
        )}
      <I18n
        render={translate => (
          <button
            className="btn btn-icon"
            onClick={nextPage}
            aria-label="Next Page"
            disabled={paging || !nextPage}
            title={translate('Next Page')}
          >
            <span className="icon">
              <span className="fa fa-fw fa-angle-right" />
            </span>
          </button>
        )}
      />
    </div>
    <div className="pagination-bar__group">
      <small className="mx-2">
        {paging ? (
          <span className="fa fa-spinner fa-spin fa-fw" />
        ) : (
          <strong>
            <I18n
              render={translate => {
                const countString = !!count
                  ? ` ${translate('of')} ${count}${!countDone ? '+' : ''}`
                  : '';
                return `${startIndex}-${endIndex}${countString}`;
              }}
            />
          </strong>
        )}
      </small>
    </div>
    {!!pageSize &&
      typeof changePageSize === 'function' && (
        <div className="pagination-bar__group ml-auto">
          <UncontrolledDropdown>
            <DropdownToggle color="link" title="Change Page Size">
              <span>
                <I18n>Per page:</I18n> <strong>{pageSize}</strong>
              </span>
              <span className="fa fa-angle-down ml-1" />
            </DropdownToggle>
            <DropdownMenu className="">
              {C.PAGE_SIZE_OPTIONS.map(size => (
                <DropdownItem
                  key={`page-size-option-${size}`}
                  onClick={changePageSize(size)}
                >
                  {size}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      )}
  </div>
);
